import { Header, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { POBillToSettingsPresenter } from '@webapp/modules/purchasing/features/set-po-bill-to-settings/presenters/POBillToSettingsPresenter'
import messages from './messages'
import { usePOBillToDefaultsView } from './usePOBillToDefaultsView'

/**
 * Feature Set: Bill to section (Bill to tab)
 *
 * Orchestrates:
 * - Heading + description, with the PunchOut caveat shown only to tenants on
 *   the `punchout` feature switch
 * - The Bill To preference query feature bridged to its command presenter
 */
export const POBillToDefaultsView = () => {
  const intl = useProcurifyIntl()

  const {
    states: {
      primaryCategory,
      contact,
      contactUser,
      isLoadingContactUser,
      isLoading,
      isDisabled,
      showPunchoutNote,
    },
  } = usePOBillToDefaultsView()

  return (
    <Space>
      <Space size='small'>
        <Header as='h3'>{intl.formatMessage(messages.heading)}</Header>
        <Text>{intl.formatMessage(messages.description)}</Text>
        {showPunchoutNote && (
          <Text>{intl.formatMessage(messages.punchoutNote)}</Text>
        )}
      </Space>

      {!isLoading && (
        <POBillToSettingsPresenter
          primaryCategory={primaryCategory}
          contact={contact}
          contactUser={contactUser}
          isLoadingContactUser={isLoadingContactUser}
          isDisabled={isDisabled}
        />
      )}
    </Space>
  )
}

POBillToDefaultsView.displayName = 'POBillToDefaultsView'
